import { render, staticRenderFns } from "./WarningAndCollectPage.vue?vue&type=template&id=702960b2&scoped=true&"
import script from "./WarningAndCollectPage.vue?vue&type=script&lang=js&"
export * from "./WarningAndCollectPage.vue?vue&type=script&lang=js&"
import style0 from "./WarningAndCollectPage.vue?vue&type=style&index=0&id=702960b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702960b2",
  null
  
)

export default component.exports